module.exports = __webpack_public_path__ + "static/media/03_reflections-burnaby.48501122.jpg";